import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { AbnDetailsCollection } from './abn-details.types';

export function abnDetailsBackend(): Backend<AbnDetailsCollection> {
  return {
    defaultOrder: {
      field: 'abn',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => {
      const abn = getQueryParamValue(query, 'abn')[0];

      if (!abn) {
        throw new Error('ABN parameter is required for ABN lookup');
      }

      return {
        endpoint: 'abn/lookup.php',
        isGaf: true,
        params: {
          abn,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
